import { render, staticRenderFns } from "./SiparisEklePopup.vue?vue&type=template&id=d90d05f6"
import script from "./SiparisEklePopup.vue?vue&type=script&lang=js"
export * from "./SiparisEklePopup.vue?vue&type=script&lang=js"
import style0 from "./SiparisEklePopup.vue?vue&type=style&index=0&id=d90d05f6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports